import {
  useEffect, useRef, useState
} from 'react';
import useSWR from 'swr';

import fetchAssayResults from '../../utils/api_functions/assayResultRequest';

import { mapAssayResults } from '../../utils/assay_utils';

export const useAssayResults = ({
  assayID,
  startTimestamp,
  endTimestamp,
  shouldFetchResults = () => null,
  validationDelay = 500,
}) => {
  const errorTimeoutRef = useRef(null);

  const [isLoading, setLoading] = useState(false);
  const [errorMessage, setError] = useState(null);

  const [currentData, setCurrentData] = useState([]);

  const {
    data,
    error,
    mutate,
  } = useSWR(shouldFetchResults() ? [assayID, startTimestamp, endTimestamp, 'assay-results'] : null, fetchAssayResults, {
    refreshInterval: 3000,
    loadingTimeout: validationDelay,
    onLoadingSlow: () => setLoading(true),
    onSuccess: () => setLoading(false),
    onError: () => setLoading(false),
  });

  useEffect(() => {
    if (data) {
      setCurrentData(data?.map(mapAssayResults));
    }
  }, [data])

  useEffect(() => {
    if (error) {
      errorTimeoutRef.current = setTimeout(() => {
        setError(error?.message);
      }, validationDelay);
    } else {
      clearTimeout(errorTimeoutRef.current);
      setError(null);
    }

    return () => {
      clearTimeout(errorTimeoutRef.current);
      setError(null);
    }
  }, [error, validationDelay]);

  return {
    data: currentData,
    error: errorMessage,
    isLoading,
    refetchAssayResults: mutate,
  };
}

export default useAssayResults;
